import { CampaignAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { ICoordinate, ICoordinateData, ICoordinateRepository, TYPE_COORDINATE } from "./model"

export const coordinateRPO: ICoordinateRepository = {
  getCoordinates(campaignId: number): Promise<ICoordinate[]> {
    return new Promise<ICoordinate[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.getApiCampaignCoordinateList(campaignId)
          .then(response => resolve(response.map(c => ({ ...c, type: TYPE_COORDINATE }))))
          .catch((error: any) => {
            console.error("Server error while getting all coordinates", error)
            reject("geo-targets.coordinate.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all coordinates", ex)
        reject("geo-targets.coordinate.get.all.error.unexpected")
      }
    })
  },
  createCoordinate(campaignId: number, coordinate: ICoordinate): Promise<ICoordinate> {
    return new Promise<ICoordinate>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignCoordinate({
          campaign_id: campaignId,
          name: coordinate.name,
          longitude: coordinate.longitude,
          latitude: coordinate.latitude,
          radius: coordinate.radius
        })
          .then(response => resolve({ ...response, type: TYPE_COORDINATE }))
          .catch((error: any) => {
            console.error("Server error while creating coordinate", error)
            reject("geo-targets.coordinate.create.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while creating coordinate", ex)
        reject("geo-targets.coordinate.create.error.unexpected")
      }
    })
  },
  createCoordinates(campaignId: number, coordinates: ICoordinate[]): Promise<ICoordinate[]> {
    return new Promise<ICoordinate[]>((resolve, reject) => {
      checkIfSessionIsOrWillExpired()
      reject("Not implemented, waiting for endpoint")
    })
  },
  updateCoordinate(campaignId: number, coordinate: ICoordinate): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.putApiCampaignCoordinate({
          campaign_id: campaignId,
          id: coordinate.id,
          name: coordinate.name,
          longitude: coordinate.longitude,
          latitude: coordinate.latitude,
          radius: coordinate.radius
        })
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while updating coordinate", error)
            reject("geo-targets.coordinate.update.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while updating coordinate", ex)
        reject("geo-targets.coordinate.update.error.unexpected")
      }
    })
  },
  setCoordinates(campaignId: number, coordinates: ICoordinateData[]): Promise<ICoordinate[]> {
    return new Promise<ICoordinate[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignCoordinateList(
          campaignId,
          coordinates.map(c => ({ ...c, campaign_id: campaignId }))
        )
          .then(response => resolve(response.map(c => ({ ...c, type: TYPE_COORDINATE }))))
          .catch((error: any) => {
            console.error("Server error while setting all coordinates", error)
            reject("geo-targets.coordinate.set.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while setting alls coordinates", ex)
        reject("geo-targets.coordinate.set.all.error.unexpected")
      }
    })
  },
  deleteCoordinate(campaignId: number, coordinateId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.deleteApiCampaignCoordinate(campaignId, coordinateId)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while deleting coordinate", error)
            reject("geo-targets.coordinate.delete.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while deleting coordinate", ex)
        reject("geo-targets.coordinate.delete.error.unexpected")
      }
    })
  }
}
